import { Check } from "lucide-react";

export function EmptyState({ text }: { text: string }) {
  return <div className="border border-dashed px-4 py-8 text-center text-sm text-muted-foreground">{text}</div>;
}

export function EnabledLabel() {
  return (
    <span className="flex items-center gap-1">
      <Check className="size-3" />
      启用中
    </span>
  );
}
